/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Rights_TitleInputs */

const es_privacy_policy_rights_title = /** @type {(inputs: Privacy_Policy_Rights_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Sus Derechos`)
};

const en_privacy_policy_rights_title = /** @type {(inputs: Privacy_Policy_Rights_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Your Rights`)
};

/**
* | output |
* | --- |
* | "7. Your Rights" |
*
* @param {Privacy_Policy_Rights_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_rights_title = /** @type {((inputs?: Privacy_Policy_Rights_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Rights_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_rights_title(inputs)
	return en_privacy_policy_rights_title(inputs)
});
export { privacy_policy_rights_title as "privacy_policy.rights.title" }